import { user as initialState } from 'flux/initialState';
import { user as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.RESET_GEOLOCATION: {
      const { geolocation } = initialState;
      return { ...state, geolocation };
    }
    case types.SET_GEOLOCATION: {
      const { geolocation } = action.payload;
      return { ...state, geolocation };
    }
    case types.SET_ID: {
      const { id } = action.payload;
      return { ...state, id };
    }
    case types.SET_SESSION_ID: {
      const { sessionId } = action.payload;
      return { ...state, sessionId };
    }
    default:
      return state;
  }
}
